import { sprite } from '../../lib';
import { gun4 } from './shared';

/**
 * Fill grid at 4× density (ADR-0073; outline added by `gun4`): green glass seed jar on a brass receiver, steel stock,
 * a steel shroud tapering to a slim muzzle, the gardener's fist on the grip (top-left of the fist = origin).
 */
const FILL = `
  ................................................................
  ................................................................
  ...........................lllllllGGG...........................
  .........................llgwwwggggGGGD.........................
  ........................llwwggggggggGGGD........................
  .......................llwgggggggggggGGGD.......................
  .......................llwgggggggggggGGGD.......................
  ......................llgggyYgggggggggGGGD......................
  ......................llgggYUggyYggggglGGD......................
  ......................llyYggggggYUgyYglGGD......................
  ......................llYUgyGGgggggYUgGGGD......................
  ......................llgggYUgggggggggGGGD......................
  ......................UyyyyyyyyyyyyyyyyyyU......................
  ......................UUUUUUUUUUUUUUUUUUUn......................
  .......444444444444425UYYYYYYYYYYYYYYYYYYYYYY...................
  .....32445555555555425UyyyyyyyyyyyyyyyyyyeUyYU..................
  ....324455555555544425yyyyyyyyyyyyyyyyyyyUnyYU5555555...........
  ...3244444444444444425yyeeeewweeeeeeeeeeyyyyYU5555555555........
  ..32344444444444444324YYYYYYYYYYYYYYYUYYYYYYUn4114114114555w54..
  ..32333333333333333324YYYYYYYYYYYYYYUyUYYYYYUn4214214214444443..
  ..32333333333333333322YYYYYYYYYYYYYUyeyUYYYYUn3443443443333332..
  ..32333333333333333322YYYYYYYYYYYYYYUyUYYYYYUn3333333333322222..
  ..32333333333333333322UUUUUUUUUUUUUUUUUUUyUUUn22222222222.......
  ..32333333333333333222UUUUUUUUUUUUUUUUUUUUnUUn22222222..........
  ..32333333322222....22UUUUUUUUUUUUUUUUUUUUUUUn..................
  ..323333322222........UUUUUUUUUUUUUUUUUUUUUUn...................
  ..3233322222..................YU43YU............................
  ..32332222....................YU.3YU............................
  ..323222......................YUUUUn............................
  ...222.........................UUUn.............................
  ................................................................
  ................................................................
  ................................................................
  ................................................................
  ................................................................
  ................................................................
`;

export default sprite({
  name: 'pollinator',
  group: 'actor',
  size: [64, 36],
  origin: [16, 20],
  hand: [16, 20],
  density: 4,
  flash: ['idle'],
  seed: 'pollinator_a',
  notes: `Seed SMG held by the gardener, facing right, rotating around the grip (origin, where the hand is).
Brass seed SMG with a round glass seed-jar hopper and a steel stock (walnut until it met the gardener's face,
shared.ts).
"Storybook" direction (material-coloured sel-out), picked in the 2026-09 art review.
4× density (ADR-0073): 64×36, origin [16,20], muzzle x=64. Redrawn natively from a Scale2x of the 2× art: the
Thornfire's steel stock (no slot), a round green jar (l lit edge, G/D shade side) with a curved w glint along its
shoulder and a loose pile of gold seeds, a smooth brass collar, a brass receiver with an e specular and w glint, a
debossed flower stamp and two rivets, a brass trigger guard round a steel trigger, a steel shroud with three cooling
holes.
2026-10: the front narrows instead of flaring. The 2026-09 round muzzle ring (taller than the shroud) and the front
sight (it read as a fin) are gone; the shroud tapers in a cone (top edge stepping a column ahead of the bottom) into a
slim 4-row barrel, the narrowest part of the gun, a w glint near its tip and its crown in shade. The front points
where it shoots, like an arrowhead: a precise single-pellet SMG, not a blunderbuss; the skins (skins.ts) recolour the
same steel keys.
Rubric: S5 R5 P5 L4 C4 F5 (2×: S5 R4 P5 L4 C4 F5). Weakest: the brass body still shares the straw hat's values when
held; the seeds float more than they pile; the shroud is a plain tube between the holes and the cone.`,
  anims: {
    idle: { frames: [gun4(FILL)] },
  },
});
